import { Theme, createStyles } from '@material-ui/core/styles';


export const styles = (theme: Theme) => createStyles({
    gridContainer: {
        margin: '140px 0px 260px 639px',
        padding: '100px 0px 70px 20px',
        display: 'flex',
        flexDirection: 'row',
        [theme.breakpoints.down(1200)]: {
              margin: '140px 0px 260px 43%',
              padding: '7% 0px 4% 0px',
        },
        [theme.breakpoints.down(1001)]: {
          margin: '140px 0px 260px 40%',
        },
        [theme.breakpoints.down(905)]: {
          margin: '140px 0px 260px 35%',
        },
        [theme.breakpoints.down(850)]: {
          margin: '140px 0px 210px 35%',
        },
        [theme.breakpoints.down(701)]: {
          margin: '100px 0px 150px 22%',
        },
        [theme.breakpoints.down(601)]: {
          margin: '100px 0px 150px 20%',
        },
        [theme.breakpoints.down(550)]: {
          margin: '100px 0px 150px 18%',
        },
        [theme.breakpoints.down(450)]: {
          margin: '80px 0px 120px 18%',
        },
        [theme.breakpoints.down(400)]: {
          margin: '60px 0px 100px 18%',
        },
    },
    textContainer: {
        width: '50%',
        alignSelf:'center',
        '& #text': {
            fontSize: '18.33px',
            fontWeight: 500,
            color: '#3D4274',
            letterSpacing: '0.75px',
            lineHeight: '26.45px',
        },
        [theme.breakpoints.down(701)]: {
          alignSelf:'end',
        },
    },
    text: {
        fontSize: '18.3px',
        color: '#3D4274',
        letterSpacing: '0.6px',
        lineHeight: '26.35px',
        fontWeight: 500,
        width: '87%',
        [theme.breakpoints.down(1001)]: {
            fontSize: '15.5px',
            lineHeight: '25px',
        },
        [theme.breakpoints.down(701)]: {
          fontSize: '15px',
          lineHeight: '22px',
        },
        [theme.breakpoints.down(550)]: {
          fontSize: '13px',
          lineHeight: '21px',
          width: '95%',
          marginBottom:'1em',
        },
        [theme.breakpoints.down(450)]: {
          fontSize: '12px',
          lineHeight: '20px',
          marginBottom:'0',
        },
        [theme.breakpoints.down(400)]: {
          fontSize: '11px',
          lineHeight: '18px',
        },
        [theme.breakpoints.down(350)]: {
          lineHeight: '17px',
        },
    },
    bigText: {
        fontSize: '100px',
        color: '#3D4274',
        letterSpacing: '0.75px',
        fontWeight: 900,
        marginLeft:'26%',
        [theme.breakpoints.down(1001)]: {
            fontSize: '90px',
        },
        [theme.breakpoints.down(905)]: {
          margin: '0% 20%',
        },
        [theme.breakpoints.down(550)]: {
          fontSize: '70px',
          margin: '0% 16%',
        },
        [theme.breakpoints.down(450)]: {
          fontSize: '60px',
        },
    },
    straightLine: {
        borderTop: '1px solid #3D4274',
        background: 'none !important',
        margin: '25px  0',
        [theme.breakpoints.down(500)]: {
          margin: '20px  0',
        },
        [theme.breakpoints.down(450)]: {
          margin: '15px  0',
        },
    },
    specialText: {
        fontSize: '18.3px',
        color: '#3D4274',
        letterSpacing: '1.7px',
        lineHeight: '30px',
        fontWeight: 700,
        margin: '0% 26%',
        [theme.breakpoints.down(1001)]: {
            fontSize: '17.5px',
            lineHeight: '28px',
        },
        [theme.breakpoints.down(905)]: {
          margin: '0% 20%',
        },
        [theme.breakpoints.down(701)]: {
          fontSize: '15px',
          lineHeight: '26px',
          margin: '0% 23%',
        },
        [theme.breakpoints.down(550)]: {
          fontSize: '13px',
          lineHeight: '25px',
          margin: '0% 18%',
        },
        [theme.breakpoints.down(450)]: {
          fontSize: '12px',
          lineHeight: '23px',
          margin: '0% 13%',
        },
        [theme.breakpoints.down(400)]: {
          fontSize: '11px',
          lineHeight: '21px',
        },
        [theme.breakpoints.down(350)]: {
          margin: '0% 15%',
        },
    },
});
